import { render, staticRenderFns } from "./orderConfrimSuccess.vue?vue&type=template&id=27533302"
import script from "./orderConfrimSuccess.vue?vue&type=script&lang=js"
export * from "./orderConfrimSuccess.vue?vue&type=script&lang=js"
import style0 from "./orderConfrimSuccess.vue?vue&type=style&index=0&id=27533302&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports